<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="planningItems"
    :indexNested="true"
    :maskFields="maskFields"
    :disablePagination="true"
    :hasTableTitle="true"
  >
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :planningOperation="planningOperation"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :planningOperation="planningOperation"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :planningOperation="planningOperation"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :planningOperation="planningOperation"
        :modelNameSingular="modelNameSingular"
      />
    </template>


    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="4"><strong class="title">Total dos Itens</strong></td>
        <td colspan="2" class="text-xs-right title"><strong>{{ this.planningItemsTotalPrice | formatCurrency }}</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total dos Itens</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.planningItemsTotalPrice | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      maskFields: [
        { field: 'unitPrice', mask: 'currency_10d' },
        { field: 'quantity', mask: 'number'},
        { field: 'price',mask: 'currency'}
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Item de Planejamento"
    },
    modelNamePlural: {
      type: String,
      default: "Itens de Planejamento"
    },
    planningItems: {
      type: Array,
      default: () => [],
    },
    planningItemsTotalPrice: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    planningOperation: Object
  },
  created() {
    this.recalculatePlanningTotalPrice();
  },
  computed: {
    tableHeaders() {
      return [
        { text: "Item", align: "left", sortable: true, value: "item.name" },
        { text: "R$", align: "left", sortable: true, value: "unitPrice" },
        { text: "Qtd.", align: "left", sortable: true, value: "quantity" },
        { text: "Und.", align: "left", sortable: true, value: "item.unit.name" },
        { text: "R$ Total", align: "left", sortable: false, value: "price" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        { text: "Ações", value: "action", sortable: false }
      ]
    }
  },
  methods: {
    entryUpdated: function(editedPlanningItem){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
      this.recalculatePlanningTotalPrice();
    },
    entryCreated: function(newPlanningItem){
      this.planningItems.push(newPlanningItem);
      this.$refs.baseIndex.showConfirmationCreateMessage();
      this.recalculatePlanningTotalPrice();
    },
    entryDeleted: function(deletedPlanningItem){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
      this.recalculatePlanningTotalPrice();
    },
    recalculatePlanningTotalPrice: function() {
      var newPlanningTotalPrice = 0;
      for (var planningItem in this.planningItems) {
        if(!this.planningItems[planningItem]._destroy) {
          newPlanningTotalPrice += this.planningItems[planningItem].price;
        }
      }
      newPlanningTotalPrice = _.round(newPlanningTotalPrice, 2);
      this.$emit('update:planningItemsTotalPrice', newPlanningTotalPrice);
    }
  }
};
</script>

<style scoped></style>
